import { Label, Stack, Text } from '@fluentui/react';
import dateformat from 'dateformat';
import QRCode from 'react-qr-code';

import logo from '../../../assets/logo.png';
import { BorderedStack, Item } from './utils';

type Props = {
  sellerPhones?: string[];
  sellerEmail?: string;
  sellerName?: string;
  serial?: string;
  formId?: string;
  versionId?: string;
  isTemplate?: boolean;
  orderCreated?: Date;
};

export const Header = (props: Props) => {
  const createdDate = props.orderCreated ?? new Date()
  return (
    <BorderedStack>
      <Item width="20%">
        <Stack
          style={{ padding: "5px" }}
          horizontal
          verticalFill
          verticalAlign="center"
          horizontalAlign="center"
        >
          <img src={logo} width="70%" />
        </Stack>
      </Item>
      <Item grow width="50%">
        <Stack verticalFill verticalAlign="center" horizontalAlign="center">
          <Text variant="xLargePlus">
            Satış {props.isTemplate ? "Teklifi" : "Sözleşmesi"}
          </Text>
          {props.sellerName && (
            <Text variant="large">
              Nilgün Pazarlama {props.sellerName} Mağazası
            </Text>
          )}
          <Label>
            {[...(props.sellerPhones || []), props.sellerEmail]
              .filter((x) => x)
              .join(" - ")}
          </Label>
        </Stack>
      </Item>
      <Item width="20%">
        <Stack
          style={{ padding: "5px" }}
          verticalFill
          verticalAlign="center"
          horizontalAlign="center"
        >
          <Stack horizontal tokens={{ childrenGap: 10 }}>
            <div>
              <QRCode
                value={`nlg.pw/${props.formId}/${props.versionId}`}
                size={64}
              />
            </div>
            {/* <img src={datamatrixURL || imagePlaceholder48} width={48} /> */}
            <div>
              <Text variant='xSmall'>Satış Tarihi</Text><br />
              <Text variant='smallPlus'>{dateformat(createdDate, "dd/mm/yyyy")}</Text><br />
              <Text variant='xSmall'>Düzenleme T.</Text><br />
              <Text variant='smallPlus'>{dateformat(new Date(), "dd/mm/yyyy")}</Text>
            </div>
          </Stack>
        </Stack>
      </Item>
    </BorderedStack>
  );
};
